import {remCalc} from '../../_utils'

// Stories

export default {
    baseStyle: ({
        autoplayDelay,
        maskgroup,
    }: {
        autoplayDelay: number
        maskgroup: {maskheaderactive?: boolean; opacity: string}
    }) => {
        // ignore opacity color, it's always black
        const maskGradient = maskgroup?.maskheaderactive ? 'rgba(0, 0, 0, 0.5)' : 'none'

        return {
            container: {
                maxW: remCalc(1920),
                position: 'relative',
                my: {base: remCalc(16), md: remCalc(40)},
                mx: 'auto',
                bgColor: 'background.default',
            },
            slidercontainer: {
                w: '100%',
                maxW: {
                    base: remCalc(343),
                    sm: remCalc(720),
                    md: remCalc(976),
                    lg: remCalc(1400),
                },
                m: '0 auto',
                bgColor: 'background.default',

                // Swiper component styling
                '.stories-pagination-bullet': {
                    borderRadius: remCalc(1),
                    h: remCalc(1.031),
                    background: 'hsla(0, 0%, 100%, .5)',
                    opacity: 1,
                    flexGrow: 1,
                    cursor: 'pointer',
                },
                '.stories-pagination-bullet span': {
                    display: 'block',
                    borderRadius: remCalc(1),
                    h: remCalc(1.031),
                    w: 0,
                    background: 'white',
                },
                '.stories-pagination-bullet.full span': {
                    w: '100%',
                },
                '.stories-pagination-bullet.current span': {
                    transition: `width ${autoplayDelay}s linear`,
                    w: '100%',
                },
                '.swiper-slide .current .slideimage': {
                    transition: `transform ${autoplayDelay}s linear`,
                    transform: 'scale(1.1)',
                },
                '.swiper-button-disabled': {
                    display: 'none',
                },
            },
            mediaContainer: {
                position: 'relative',
                w: '100%',
                h: '100%',
            },
            screenImg: {
                w: '100%',
                h: '100%',
                objectFit: 'cover',
            },
            screenText: {
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: '50%',
                flexDirection: 'column',
                transform: 'translateX(-50%)',
                justifyContent: 'center',
                alignItems: 'center',
                w: '100%',
                background: maskGradient,
            },
            heading: {
                mb: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
                w: '80%',
                color: 'text.inverse',
                textAlign: 'center',
                textTransform: 'none',
                textStyle: 'display-small',
                fontWeight: 'medium',
            },
            startctacontainer: {
                textAlign: 'center',
            },
            startcta: {
                minW: {base: remCalc(214), lg: remCalc(230), md: remCalc(310)},
            },
            closeButton: {
                zIndex: 3,
                color: 'text.inverse',
                position: 'absolute',
                top: {base: remCalc(12), sm: remCalc(14), md: remCalc(12)},
                right: {base: remCalc(12), sm: remCalc(14), md: remCalc(12)},
                w: {
                    base: 'iconsSize.medium',
                    lg: 'iconsSize.large',
                    xl: 'iconsSize.xlarge',
                },
                h: {
                    base: 'iconsSize.medium',
                    lg: 'iconsSize.large',
                    xl: 'iconsSize.xlarge',
                },
                fontSize: {base: remCalc(15), md: remCalc(16), lg: remCalc(20), xl: remCalc(24)},
            },
            chevronIcon: {
                w: {
                    base: 'iconsSize.medium',
                    lg: 'iconsSize.large',
                    xl: 'iconsSize.xlarge',
                },
                h: {
                    base: 'iconsSize.medium',
                    lg: 'iconsSize.large',
                    xl: 'iconsSize.xlarge',
                },
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                borderRadius: '50%',
                cursor: 'pointer',
                zIndex: 10,
                background: 'colors.null',
                color: 'text.inverse',
            },
            slide: {
                flexDirection: 'column',
                color: 'text.inverse',
                w: '100%',
                maxW: '100%',
                h: '100%',
                maxH: '100%',
                overflow: 'hidden',
            },
            slidemedia: {
                w: '100%',
                h: '100%',
                objectFit: 'cover',
                zIndex: 1,
            },
            slidetextblock: {
                position: 'absolute',
                top: 0,
                left: '50%',
                flexDirection: 'column',
                transform: 'translateX(-50%)',
                w: '80%',
                h: {base: `calc(100% - ${remCalc(34)})`, sm: `calc(100% - ${remCalc(50)})`},
                alignItems: 'flex-start',
                justifyContent: 'flex-end',
                zIndex: 3,
                gap: {base: remCalc(16), sm: remCalc(24)},
            },
            slidetitle: {
                w: '100%',
                textAlign: 'left',
            },
            slidetitletext: {
                textStyle: 'head-xlarge',
                fontWeight: 'medium',
            },
            slidebodycopy: {
                w: '100%',
                textAlign: 'left',
            },
            slidebodycopyhtml: {
                textStyle: 'body-large',
                fontWeight: 'normal',
            },
            slidemask: {
                position: 'absolute',
                w: '100%',
                h: '100%',
                background: maskGradient,
                zIndex: 2,
            },
            pagination: {
                zIndex: 10,
                position: 'absolute',
                bottom: {base: `${remCalc(16)} !important`, md: `${remCalc(24)} !important`},
                left: '50% !important',
                flexDirection: 'row',
                transform: 'translateX(-50%)',
                w: '80% !important',
                justifyContent: 'space-between',
                gap: remCalc(24),
            },
            endctacontainer: {
                textAlign: 'center',
            },
            endcta: {
                minW: {base: remCalc(214), lg: remCalc(230), md: remCalc(310)},
            },
        }
    },
}
